export default __webpack_public_path__ + "media/c49c727b0cc6bf5a3b22261243b8699997801ef4b26975155f5f39b75d2eec4b.svg";